export default [
  {
    path: '/activity-20250810-main',
    component: () => import('./Page.vue'),
    meta: { expire: '2025-08-20T23:59:59.000+08:00', title: '心动圆舞曲' },
  },
  {
    path: '/activity-20250810-rule',
    component: () => import('./Rule.vue'),
    meta: { expire: '2025-08-20T23:59:59.000+08:00', title: '心动圆舞曲-规则说明' },
  },
]
